<div class="calendar-weeks" fxLayout="column" fxLayoutAlign="space-between center" style="width:100%;">
  @for (week of displayedWeeks; track week) {
    <div class="calendar-week" fxLayout="row" fxLayoutAlign="space-between center"
      style="width:100%;height:112px;">
      @for (day of week; track day) {
        <div fxFlex="15" fxLayout="row" fxLayoutAlign="space-between center"
          [ngClass]="{'last-day-of-week':$last}" style="position: relative;" class="metadata-calendar-day">
          <div class="calendar-date" fxLayout="column" [ngClass]="{'no-date': !dateInMonth(day)}"> <!--  -->
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <span fxFlex="auto"></span>
              <span class="calendar-number forge-typography--body1">{{day | date: 'd'}}</span>
            </div>
            @if (hasDayEvents(day)) {
              <div fxLayout="column" fxLayoutAlign="space-between center" class="calendar-day--event-container" style="position: relative;">
                @for (event of dayEvents(day); track event; let i = $index) {
                  <div
                    class="calendar-day--event event-color-{{event.Color}}"
                    [ngStyle]="{'width': eventWidth(event), 'top': i * 22 + 'px'}" [ngClass]="dateRangeClass(event)">
                    <div (click)="onClick($event, event)" role="button" tabindex="0"
                      class="forge-typography--label1 calendar-day--event-element" (keydown)="onEventKeyDown($event, event)"
                      [attr.aria-label]="event.DateKey">
                      <span class="calendar-day--event-text" [ngStyle]="{'max-width': eventMaxWidth(event)}">
                        {{showLabel(event) ? event.DateKey : ''}}
                      </span>
                    </div>
                    @if (event.DateKey) {
                      <forge-tooltip placement="bottom">{{event.DateKey}}</forge-tooltip>
                    }
                  </div>
                }
                @if (eventOverflow(day)) {
                  <forge-button type="button" pill variant="link" [id]="viewAllId(day)" class="calendar-day--view-all">
                    <span class="forge-typography--label1 calendar-day--view-all-label">View all (+{{overflowEventsCount(day)}})</span>
                  </forge-button>
                }
                @if (eventOverflow(day)) {
                  <forge-popover #popover [attr.anchor]="viewAllId(day)" placement="bottom" position-strategy="fixed">
                    <forge-scaffold class="calendar-all-day-events">
                      <div slot="header" class="calendar-all-day-events--header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="forge-typography--heading1" style="color: var(--forge-theme-text-high);">
                          {{day | date: 'MMMM d, yyyy'}}
                        </div>
                        <forge-icon-button type="button" dense aria-label="close" (click)="popover.open = false" style="margin-right: .25rem;">
                          <forge-icon name="close"></forge-icon>
                        </forge-icon-button>
                      </div>
                      <div slot="body" fxLayout="column" class="calendar-all-day-events--body">
                        @for (event of allDailyEvents(day); track event) {
                          <div (click)="popover.open = false; onClick($event, event);" tabindex="0" role="button"
                            class="calendar-all-day-events--event event-color-{{event.Color}}" [ngClass]="dateRangeClass(event)" (keydown)="onEventKeyDown($event, event)">
                            @if (event.DateKey) {
                              <div fxLayout="row" fxLayoutAlign="space-between center"
                                class="forge-typography--body1 calendar-day--event-show-all">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                  <div class="calendar-day--event-range overflow-before">
                                    <forge-icon name="arrow_back"></forge-icon>
                                  </div>
                                  <div class="calendar-day--event-show-all-text">
                                    <truncate-text [mainText]="event.ShowDetail ? event.DateDetail : event.DateKey" allow-tooltip="true"></truncate-text>
                                  </div>
                                </div>
                                <div class="calendar-day--event-range overflow-after">
                                  <forge-icon name="arrow_forward"></forge-icon>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </forge-scaffold>
                  </forge-popover>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>